.notification {
    box-shadow: 0px 4px 8px rgba(3, 7, 18, 0.03),
        1px 16px 30px rgba(3, 7, 18, 0.05);
}

.content {
    padding: var(--mantine-spacing-xs);
}

.header {
    font-size: var(--mantine-font-size-md);
    && {
        margin: 0;
    }
}
